import { render } from "./StrategesInfoEng.vue?vue&type=template&id=39bf5238"
import script from "./StrategesInfoEng.vue?vue&type=script&lang=js"
export * from "./StrategesInfoEng.vue?vue&type=script&lang=js"

import "./StrategesInfoEng.vue?vue&type=style&index=0&id=39bf5238&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__